import { Loader2, Navigation } from 'lucide-react';
import UnifiedMap from '../UnifiedMap';

export default function MapSection({
  mapCenter,
  mapReady,
  selectedLocation,
  isLocating,
  isReverseGeocoding,
  onMapClick,
  onDetectLocation
}) {
  return (
    <div className="flex-1 relative" style={{ position: 'relative', zIndex: 1, minHeight: '200px' }}>
      {/* Map loading indicator */}
      {!mapReady && (
        <div className="absolute inset-0 bg-stone-100 flex items-center justify-center z-5">
          <div className="text-center">
            <Loader2 className="w-8 h-8 animate-spin text-amber-500 mx-auto mb-2" />
            <p className="text-sm text-stone-500">Loading map...</p>
          </div>
        </div>
      )}
      
      <UnifiedMap
        center={mapCenter}
        zoom={16}
        markers={selectedLocation.lat ? [{ lat: selectedLocation.lat, lng: selectedLocation.lng, color: 'red' }] : []}
        onClick={onMapClick}
        height="100%"
        className="rounded-none border-0"
      />
      
      {/* Center pin indicator - Orange HandyBayani branding */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 pointer-events-none" style={{ transform: 'translate(-50%, -100%)', zIndex: 10 }}>
        {/* Pin shape */}
        <div className="relative">
          {/* Pin head */}
          <div className="w-10 h-10 bg-amber-500 rounded-full border-4 border-white shadow-lg flex items-center justify-center">
            <div className="w-3 h-3 bg-white rounded-full" />
          </div>
          {/* Pin tail */}
          <div className="absolute left-1/2 -translate-x-1/2 -bottom-2 w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-t-[12px] border-t-amber-500" style={{ filter: 'drop-shadow(0 2px 2px rgba(0,0,0,0.2))' }} />
        </div>
        {/* Shadow on ground */}
        <div className="absolute top-full left-1/2 -translate-x-1/2 mt-1 w-6 h-2 bg-black/20 rounded-full blur-sm" />
      </div>

      {/* Current location button */}
      <button
        type="button"
        onClick={onDetectLocation}
        disabled={isLocating}
        className="absolute bottom-4 right-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-stone-50 active:bg-stone-100 disabled:opacity-50 transition-colors"
        data-testid="detect-location-btn"
        style={{ zIndex: 15, touchAction: 'manipulation' }}
      >
        {isLocating ? (
          <Loader2 className="w-5 h-5 animate-spin text-blue-600" />
        ) : (
          <Navigation className="w-5 h-5 text-blue-600" />
        )}
      </button>

      {/* Reverse geocoding indicator */}
      {isReverseGeocoding && (
        <div className="absolute top-4 left-1/2 -translate-x-1/2 bg-black/70 text-white text-sm px-3 py-1.5 rounded-full flex items-center gap-2" style={{ zIndex: 15 }}>
          <Loader2 className="w-4 h-4 animate-spin" />
          Getting address...
        </div>
      )}
    </div>
  );
}
